import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextInputField from "../../components/forms/TextInputField";
import BooleanInputField from "../../components/forms/BooleanInputField";
import DropDownInputField from "../../components/forms/DropDownInputField";
import TelephoneInputField from "../../components/forms/TelephoneInputField";
import {fromJS, List} from "immutable";
import normalizePhoneNr from "../../lib/TelephoneNormalizer";
import FormError from "../../components/forms/FormError";

function toUpperCase(val) {
  return val && val.toUpperCase();
}

class ShippingAddressForm extends Component {

  render() {
    let {errors, handleSubmit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    const addressTypes = fromJS([
      {id: "private", label: "Private address"},
      {id: "business", label: "Business address"},
    ]);

    let stateProvinceInput = null;
    if (this.props.showStateProvince) {
      stateProvinceInput = <Field
                              label="State / Province"
                              name="addressStateProvince"
                              component={TextInputField}
                              serverError={this.props.errors.addressStateProvince}
                              />
    }
    if (this.props.stateProvinces.size > 0) {
      stateProvinceInput = <Field
        label="State / Province"
        name="addressStateProvince"
        component={DropDownInputField}
        data={this.props.stateProvinces}
        valueKey="code"  
        titleKey="name"
        serverError={this.props.errors.addressStateProvince}
        />
      }

    // A name for the address itself, for addresses kept on file (a
    // partner's "Amazon BHX4"). Shipping orders do not show it.
    let labelField = null;
    if (this.props.showLabel) {
      labelField = <Field
        label="Label"
        name="label"
        placeholder="How you know it, e.g. Amazon BHX4"
        component={TextInputField}
        serverError={this.props.errors.label}
        />
    }

    let attField = null;
    if (this.props.showAttentionName) {
      attField = <Field
        label="Att. Name"
        name="attName"
        placeholder=""
        component={TextInputField}
        serverError={this.props.errors.attName}
        />

    }

    let phoneField = null;
    if (this.props.showPhoneNr) {
      phoneField = <Field
        label="Telephone"
        name="phoneNr"
        mode=""
        normalize={normalizePhoneNr}
        component={TelephoneInputField}
        serverError={this.props.errors.phoneNr}
        />
    }

    let dialCodeWarning = null;
    if (this.props.showDialCodeMismatchWarning && this.props.showPhoneNr) {
      dialCodeWarning = (
        <tr>
          <th></th>
          <td><p className="fieldSuggestion">To receive updates from the courier please enter a valid phone number in the destination country. If you choose to confirm anyway, you will only receive Email updates.</p></td>
        </tr>
      )
    }

    let emailField = null;
    if (this.props.showEmail) {
      emailField = <Field
        label="Email"
        name="email"
        component={TextInputField}
        serverError={this.props.errors.email}
        />
    }

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            {labelField}
            <Field
              label="Type"
              name="type"
              component={DropDownInputField}
              data={addressTypes}
              valueKey="id"  
              titleKey="label" 
              serverError={this.props.errors.type}
              />                        
            <Field
              label="Recipient"
              name="name"
              placeholder=""
              component={TextInputField}
              serverError={this.props.errors.name}
              />
            {attField}
            {dialCodeWarning}
            {phoneField}
            {emailField}
            <Field
              label="Country"
              name="addressCountryCode"
              component={DropDownInputField}
              data={this.props.countries}
              valueKey="code"  
              titleKey="name" 
              serverError={this.props.errors.addressCountryCode}
              />
            <Field
              label="Address Line 1"
              name="addressAddressLine1"
              component={TextInputField}
              serverError={this.props.errors.addressAddressLine1}
              />
            <Field
              label="Address Line 2"
              name="addressAddressLine2"
              component={TextInputField}
              serverError={this.props.errors.addressAddressLine2}
              />
            <Field
              label="City"
              name="addressCity"
              component={TextInputField}
              serverError={this.props.errors.addressCity}
              />
            <Field
              label="Postal Code"
              name="addressPostcode"
              normalize={toUpperCase}
              component={TextInputField}
              serverError={this.props.errors.addressPostcode}
              />

            {stateProvinceInput}

            <Field
              label="Ignore address validation"
              name="skipAddressValidation"
              component={BooleanInputField}
              serverError={this.props.errors.skipAddressValidation}
              />
            
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton onClick={handleSubmit(values => this.props.onSubmit(values))} label={submitLabel} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
          <ActionButton label="Delete" active={!submitting} onClick={this.props.onDelete} show={this.props.showDelete} />
        </div>
      </form>
    )
  }
}

ShippingAddressForm.defaultProps = {
  stateProvinces: List([]),
  showStateProvince: true,
  showDelete: false,
  showAttentionName: false,
  showLabel: false,
  showPhoneNr: false,
  showEmail: false,
  showDialCodeMismatchWarning: true
}

const ReduxForm = reduxForm({
  form: "ShippingAddressForm"
})(ShippingAddressForm);

export default ReduxForm;